import simpleParallax from 'simple-parallax-js';
import LazyLoad from 'vanilla-lazyload';

export default () => {

    document.querySelectorAll('[data-parallax]').forEach((item) => {

        let options = {
            overflow: true,
            delay: 1,
        };

        const dataOrientation = item.dataset.parallaxOrientation;
        if (dataOrientation) options.orientation = dataOrientation;

        const dataScale = item.dataset.parallaxScale;
        if (dataScale) options.scale = dataScale;

        new simpleParallax(item, options);

    });

    window.onload = () => {
        new LazyLoad({
            elements_selector: '[data-animate-sect]',
            class_entered: '_animate',
            threshold: -150
        });
    }

}